import Vue from 'vue';
import { toast } from '@mx/vix';

import { mixinEHBridge } from './EHbridge';

interface IdentifyIdCardProcessTypes {
  process: number;
  bizId: number;
  customId: string;
  commonColor: string;
  textColor: string;
  success: (res: any) => void;
  fail: (res: any) => void;
}
interface NfcIdentifyProcessTypes {
  action: string;
  success: (res: any) => void;
  fail: (res: any) => void;
}
interface SetResultTypes {
  resultCode: any;
  resultData: string;
  success: () => void;
  fail: () => void;
}

interface GetResultTypes {
  success: () => void;
  fail: () => void;
}
interface GetStorageConfig {
  key: string;
  success?: (o: any) => void;
  fail?: FailCallback;
}
interface SubscribeTypes {
  action: string;
  handle: () => void;
  success: (data: SubscribeTypesSuccess) => void;
  fail: (err: any) => void;
}
interface SubscribeTypesSuccess {
  subId: string;
}
interface UnsubscribeTypes {
  subId: string;
  action: string;
  success: () => void;
  fail: (err: any) => void;
}

class Bridge {
  // fingerprint = '';

  // constructor() {
  //   this.initFingerprint();
  // }

  // initFingerprint() {
  //   KNB.ready(() => {
  //     KNB.getFingerprint({
  //       success: (ret) => {
  //         this.fingerprint = ret.fingerprint;
  //       }
  //     });
  //   });
  // }

  setTitle(title: string) {
    document.title = title;
    KNB.ready(() => {
      KNB.setTitle({ title });
    });
  }

  // 设置返回按钮
  setLLButton(handle: () => void, content?: string) {
    let llButtonConfig = { handle } as KNBLLButtonConfig;
    if (!content) {
      llButtonConfig = { ...llButtonConfig, icon: 'H5_Back' };
    } else if (this.isBase64(content)) {
      llButtonConfig = { ...llButtonConfig, type: 'base64', icon: content };
    } else {
      llButtonConfig = { ...llButtonConfig, type: 'text', text: content };
    }
    KNB.ready(() => {
      KNB.setLLButton(llButtonConfig);
    });
  }

  // 设置右上角按钮
  setRRButton(handle: () => void, content: string) {
    let rrButtonConfig = { handle, position: 'RR' } as KNBNavButtonsConfig;
    if (this.isBase64(content)) {
      rrButtonConfig = { ...rrButtonConfig, type: 'base64', icon: content };
    } else {
      rrButtonConfig = { ...rrButtonConfig, type: 'text', text: content };
    }
    KNB.ready(() => {
      KNB.setNavButtons(rrButtonConfig);
    });
  }
  resetNavButton(position: string = 'RR') {
    KNB.ready(() => {
      KNB.setNavButtons({
        position,
        disable: 1
      });
    });
  }

  // 登录
  login(): void {
    const loginTimeKey = 'payfe_login_time';
    const loginTime = Number(sessionStorage.getItem(loginTimeKey)) || 1;
    sessionStorage.setItem(loginTimeKey, loginTime + 1 + '');

    if (loginTime > 3) {
      setTimeout(() => {
        toast.show('text', '登录状态有点问题，请稍后再试');
      }, 0);
      sessionStorage.removeItem(loginTimeKey);
      return;
    }

    KNB.ready(() => {
      if (KNB.env.isNative) {
        this.knbLogin();
      } else {
        this.webLogin();
      }
    });
  }
  webLogin(): void {
    location.href = `https://i.meituan.com/account/login?backurl=${encodeURIComponent(
      location.href
    )}`;
  }
  knbLogin(): void {
    KNB.ready(() => {
      KNB.login({
        success: () => {
          location.reload();
        }
      });
    });
  }
  // 身份验证桥
  identifyIdCardProcess(params: IdentifyIdCardProcessTypes) {
    KNB.ready(() => {
      KNB.use('pay.identifyIdCardProcess', {
        process: params.process,
        bizId: params.bizId,
        customId: params.customId,
        commonColor: params.commonColor,
        textColor: params.textColor,
        success: params.success,
        fail: params.fail
      });
    });
  }

  nfcIdentifyProcess(params: NfcIdentifyProcessTypes) {
    KNB.ready(() => {
      KNB.use('pay.nfcIdentify', {
        action: params.action,
        success: params.success,
        fail: params.fail
      });
    });
  }

  // webkit通知native调用方
  setResult(params: SetResultTypes) {
    KNB.ready(() => {
      KNB.setResult(params);
    });
  }
  getResult(params: GetResultTypes) {
    KNB.ready(() => {
      KNB.getResult(params);
    });
  }
  getStorage(config: GetStorageConfig) {
    KNB.ready(() => {
      KNB.getStorage(config);
    });
  }
  jumpWebView(url: string) {
    KNB.ready(() => {
      KNB.jumpWebview({
        url
      });
    });
  }
  subscribe(params: SubscribeTypes) {
    if (KNB.env.isNative) {
      KNB.ready(() => {
        KNB.subscribe({
          action: params.action,
          handle: params.handle,
          success: params.success,
          fail: params.fail
        });
      });
    }
  }
  unSubscribe(params: UnsubscribeTypes) {
    if (KNB.env.isNative) {
      KNB.ready(() => {
        KNB.unsubscribe({
          subId: params.subId,
          action: params.action,
          success: params.success,
          fail: params.fail
        });
      });
    }
  }

  private isBase64(content: string): boolean {
    return content.indexOf('data:image') === 0;
  }
}

const MixinEHBridge = mixinEHBridge(Bridge);
export const bridge = new MixinEHBridge();

// extend Vue prototype
declare module 'vue/types/vue' {
  interface Vue {
    $bridge: typeof bridge;
  }
}

Vue.prototype.$bridge = bridge;
